import { render, staticRenderFns } from "./PalletInChamberDetail.vue?vue&type=template&id=48f62f90"
import script from "./PalletInChamberDetail.vue?vue&type=script&lang=js"
export * from "./PalletInChamberDetail.vue?vue&type=script&lang=js"
import style0 from "./PalletInChamberDetail.vue?vue&type=style&index=0&id=48f62f90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports